export const getDeepCopyOfObject = obj => {
    return JSON.parse(JSON.stringify(obj));
};